module.exports = __webpack_public_path__ + "img/hbo.3b871074.jpg";